module.exports = __webpack_public_path__ + "img/monitor.93eebcf8.svg";